import React, { useState, useEffect } from "react";
import data from "../data/patents.json";
import axios from "axios";
import landingData from "../data/landingPage.json";
import company from "../data/pressReleases.json";
import { createContext } from "react";
export const PatentContext = createContext();
export default function PatentContextProvider({ children }) {
  const [patentsData, setPatentsData] = useState(data?.patents);
  const [landingPageData, setLandingPageData] = useState(landingData?.landingPagePalm)
  const [pressReleases, setPressReleases] = useState(company?.pressReleases);
  const [patentLicensingModal, setPatentLicensingModal] = useState(false);
  const [selectedPatent, setSelectedPatent] = useState(data?.patents[0]);
  const [selectedFullPatent, setSelectedFullPatent] = useState()
  const [audioPlayed, setAudioPlayed] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [userData, setUserData] = useState();
  const [activeLink, setActiveLink] = useState(() => {
    const checkActiveLink = localStorage.getItem("activelink");
    try {
      return checkActiveLink ? JSON.parse(checkActiveLink) : null;
    } catch (error) {
      return null;
    }
  });
  const [role, setRole] = useState(null);
  const token = localStorage.getItem("token");
  useEffect(() => {
    const getUserRole = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_PATH}/me`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        setRole(response.data.role);
      } catch (error) {
        console.log('error', error)
      }
    }
    if (token) getUserRole();
  }, [token])

  const [active, setActive] = useState(() => {
    const checkActivePatent = localStorage.getItem("activePatent");
    try {
      return checkActivePatent ? JSON.parse(checkActivePatent) : null;
    } catch (error) {
      return null;
    }
  });

  const [animate, setAnimate] = useState(() => {
    const checkAnimation = localStorage.getItem("animate");
    return checkAnimation ? JSON.parse(checkAnimation) : true;
  });

  const [playMusic, setPlayMusic] = useState(() => {
    const checkMusicPlay = localStorage.getItem("playMusic");
    return checkMusicPlay ? JSON.parse(checkMusicPlay) : false;
  });

  const [isLoading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // Video State
  const [videoCurrentTime, setVideoCurrentTime] = useState(localStorage.getItem("videoCurrentTime") || 0);
  const [allPages, setAllPages] = useState([]);
  //refs//
  //saving video time//
  useEffect(() => {
    localStorage.setItem("videoCurrentTime", videoCurrentTime);
  }, [videoCurrentTime]);

  useEffect(() => {
    setPatentsData(data.patents);
    setLandingPageData(landingData.landingPagePalm)
  }, [videoCurrentTime]);

  const handlePatentClick = (patentId) => {
    setActive(patentId);
    patentSelected(patentId);
    localStorage.setItem("activePatent", JSON.stringify(patentId));
    setMenuOpen(false);
  };

  const patentSelected = (patentId) => {
    const choosenPatent = patentsData.find(
      (patent) => patent.patentId.replace(/[\s,]/g, "") === patentId
    );
    if (choosenPatent) {
      setSelectedPatent(choosenPatent);
    }
  };
  const handleLinkClick = (path) => {
    setActiveLink(path);
    localStorage.setItem("activelink", JSON.stringify(path));
  };

  return (
    <PatentContext.Provider
      value={{
        patentsData,
        landingPageData,
        userData,
        role,
        setRole,
        setUserData,
        setPatentsData,
        isLoading,
        setLoading,
        error,
        setError,
        selectedPatent,
        patentSelected,
        selectedFullPatent,
        setVideoCurrentTime,
        audioPlayed,
        setAudioPlayed,
        playMusic,
        setPlayMusic,
        animate,
        setAnimate,
        active,
        setActive,
        handlePatentClick,
        menuOpen,
        setMenuOpen,
        handleLinkClick,
        activeLink,
        setActiveLink,
        menuOpen,
        patentLicensingModal,
        setPatentLicensingModal,
        pressReleases,
        allPages,
        setAllPages,
      }}
    >
      {children}
    </PatentContext.Provider>
  );
}
